import type { FaireProductEntity } from "../../entity_types/product";

export const p_av9t78g3sd: FaireProductEntity = {
  token: "p_av9t78g3sd",
  type: "product",
  name: "Moroccan Terracotta Cups",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/eef6edcee8863eba8d2d0b9424fdbb02b0e54eec9c5c7ca8a09fb9c5a789b8ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/131ed842fdfb1ce6d1ba9c1d3bd7c1dc0a0c5a42f208f30fac83b26039eb17ad.jpeg",
    "https://cdn.faire.com/fastly/6ea9771609cf883064251a00a3209c96d2205b6f61343b529df374380d775c06.jpeg",
    "https://cdn.faire.com/fastly/13e19c7800d72e54ce80ac1f7f9c5536dbd8d736d7da4fe744dc5654d8f83406.jpeg",
    "https://cdn.faire.com/fastly/b8817890a5943cbd0e55984b31391e91f917ca453c2070bea47e706cdff3d899.jpeg",
    "https://cdn.faire.com/fastly/25bcc2b1cddca5ffc23160c64207b02ba545dc3aef98ffcf78e981562392c97e.jpeg",
    "https://cdn.faire.com/fastly/9858f4b8b60de3f6abec044c6b727e9b0024257d4e99ba715bde7c2f341eff42.jpeg",
    "https://cdn.faire.com/fastly/8c504a2692a106ac03a79a2f3c0f7dbbe746f55c5ed11b3ef1ebc994e04ad156.jpeg",
  ],
  priceDollars: 6.25,
  description:
    "Handcrafted with tradition and artistry, this glazed terracotta cup brings the vibrant spirit of Morocco to your table. Made by skilled artisans near Marrakesh, each cup is formed from locally sourced clay and carefully hand-dipped in cream or rust colored glaze to help insulate. The glazing process gives the cup a beautifully smooth finish, enhancing its rich colors and durability. Ideal for both hot and cold beverages, this cup is perfect for savoring coffee, wine, or even chilled mint tea. Functional and decorative, these cups add a touch of Moroccan warmth and authenticity to any kitchen or dining space.\n\nWe recommend hand-washing due to the porous nature of the terracotta. It is normal to see fine feathering cracks in the glaze.\n\nSold individually.\n\n2.5'' height x 2.6'' diameter \n4.5 oz / 130 ml capacity",
  tags: [],
  msrpDollars: 12.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:18.281Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
